import React from 'react';
import { func, string } from 'prop-types';
import styled from 'styled-components';

import SearchSvg from 'library/icons/search.svg';
import Input from 'library/components/form-elements/input';
import SearchFilter from 'apps/hs-planning/components/search-filter';

const SearchBar = styled.div`
  position: relative;
  background: #f5f5f2;
`;

const StyledSearch = styled.div`
  position: relative;
  width: 666px;
  max-width: calc(100vw - 2em);
  margin: auto;

  .highlight {
    font-weight: bold;
    color: #2E2E2E;
  }

  div {
    position: relative;
    > svg {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
      height: 1.5em;
    }
  }
`;

const CourseSearch = (props) => {
  const handleChange = (e) => {
    let val = e.target.value;
    props.setSearchQuery(val);
  };

  return (
    <StyledSearch>
      <div>
        <Input
          component={SearchBar}
          label='Search for classes...'
          value={props.searchQuery}
          onChange={handleChange}
          delayInput={true}
        />
        <SearchSvg />
      </div>
      <SearchFilter setFilters={props.setFilters}/>
    </StyledSearch>
  );
};

CourseSearch.propTypes = {
  searchQuery: string,
  setSearchQuery: func,
  setSearching: func
};

export default CourseSearch;
